var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0206 11.078L14.876 13.9327L13.9326 14.876L11.078 12.0207C10.0158 12.8721 8.69465 13.3353 7.33331 13.3333C4.02131 13.3333 1.33331 10.6453 1.33331 7.33333C1.33331 4.02133 4.02131 1.33333 7.33331 1.33333C10.6453 1.33333 13.3333 4.02133 13.3333 7.33333C13.3352 8.69467 12.8721 10.0158 12.0206 11.078ZM10.6833 10.5833C11.5294 9.71326 12.0019 8.54695 12 7.33333C12 4.75467 9.91131 2.66667 7.33331 2.66667C4.75465 2.66667 2.66665 4.75467 2.66665 7.33333C2.66665 9.91133 4.75465 12 7.33331 12C8.54693 12.0019 9.71324 11.5294 10.5833 10.6833L10.6833 10.5833Z",
    fill: "#0D1126",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.3c62656056d5bc8b1e8a05746d0fc5fa.svg";
export { ForwardRef as ReactComponent };